import React from 'react';
import { useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from 'src/componets/Pagination';

import '../style.scss';
import { EntityId } from "@reduxjs/toolkit";
import Card from "../../../mine_craft/Frames/_partials/_Card";
import { selectFrameEntities, selectFrameIds } from "../../../../store/mine_craft/framesSlice";
import Edit from "../Edit";

interface propsInterface {
  limit: number;
  pagination: boolean;
}

const _List = ({ limit, pagination }: propsInterface) => {
  const count  = useAppSelector(state => state.mineCraft.frames.count);
  const error  = useAppSelector(state => state.mineCraft.frames.error);
  const status = useAppSelector(state => state.mineCraft.frames.status);
  const ids = useAppSelector(selectFrameIds);
  const frames = useAppSelector(selectFrameEntities);

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  const renderFrame = (id: EntityId) => {
    const frame = frames[id];

    if (!frame) {
      return;
    }

    return <Card frame={frame} key={`frame-${id}`} />;
  }

  return (
    <>
      {ids && ids.map(renderFrame)}

      {pagination && <Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
